<template>
  <div>
    <div class="section">
      <div class="container section__content center">
        <div class="mobileCarousel" ref="mobileCarousel">
          <div class="carousel-cell" v-for="sign in data" :key="sign.key">
            <div class="signIcon blue sm" :id="sign.name">
              <!-- <div class="signIcon__label">{{ sign.name }}</div> -->
              <router-link :to="{ name: 'HoroscopeDetails', params: { sign: sign.name } }">
                <div style="position: relative">
                  <span class="signIcon__img" :style="{ '-webkit-mask': `url(${sign.icon})` }"></span>
                  <span class="shadow"></span>
                </div>
                <span class="signIcon__label" style="text-decoration:none; color: white;">{{sign.name}}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container section__content">
        <h2 class="std__subtile daily">{{ $route.params.sign }} {{$t("daily_horo")}}</h2>
        <!-- <p class="std__subtile sm purple">{{ today.current_date }}</p> -->
        <p class="std__subtile sm purple">{{ date_current[`${language}`] }}</p>
        <!-- <p class="std__subtile sm purple" v-if="language !== 'english'">{{ currentDateTranslate }}</p> -->
        <div class="row">
          <div class="col-md-8 order-2 order-md-1 m2--topBtm">
            <ul class="nav nav-tabs custom" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="yesterday-tab"
                  data-toggle="tab"
                  href="#yesterday"
                  role="tab"
                  aria-controls="yesterday"
                  aria-selected="false"
                >{{$t("yesterday")}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="today-tab"
                  data-toggle="tab"
                  href="#today"
                  role="tab"
                  aria-controls="today"
                  aria-selected="true"
                >{{$t("today")}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tomorrow-tab"
                  data-toggle="tab"
                  href="#tomorrow"
                  role="tab"
                  aria-controls="tomorrow"
                  aria-selected="false"
                >{{$t("tomorrow")}}</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade" id="yesterday" role="tabpanel" aria-labelledby="yesterday-tab">
                <p class="std__txt" v-if="!loading">{{ data_desc.yesterday[`${language}`] }}</p>
              </div>
              <div class="tab-pane fade show active" id="today" role="tabpanel" aria-labelledby="today-tab"> 
                <p class="std__txt" v-if="!loading">{{ data_desc.today[`${language}`] }}</p>
              </div>
              <div class="tab-pane fade" id="tomorrow" role="tabpanel" aria-labelledby="tomorrow-tab">
                <p class="std__txt" v-if="!loading">{{ data_desc.tomorrow[`${language}`] }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 order-1 order-md-2 m2--topBtm">
            <div class="imagePlaceholder">
              <img :src="image" :alt="this.sign" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 m2--topBtm">
            <ul class="nav nav-tabs custom" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="week-tab"
                  data-toggle="tab"
                  href="#week"
                  role="tab"
                  aria-controls="week"
                  aria-selected="true"
                >{{$t("week")}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="month-tab"
                  data-toggle="tab"
                  href="#month"
                  role="tab"
                  aria-controls="month"
                  aria-selected="false"
                >{{$t("month")}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="year-tab"
                  data-toggle="tab"
                  href="#year"
                  role="tab"
                  aria-controls="year"
                  aria-selected="false"
                >{{$t("year")}}</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="week" role="tabpanel" aria-labelledby="week-tab" >
                <p class="std__txt" v-if="!loading">{{ data_desc.week[`${language}`] }}</p>
              </div>
              <div class="tab-pane fade" id="month" role="tabpanel" aria-labelledby="month-tab">
                <p class="std__txt" v-if="!loading">{{ data_desc.month[`${language}`] }}</p>
              </div>
              <div class="tab-pane fade" id="year" role="tabpanel" aria-labelledby="year-tab">
                <p class="std__txt" v-if="!loading">{{ data_desc.year[`${language}`] }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Flickity from "flickity";
import aztroJs from "aztro-js";
import mobiscope_route from "../../router/mobiscope.js"
import horoscope_sign from "./horoscope_sign.json"
import { mapGetters, mapActions } from "vuex";
const proxyurl = "https://cors-anywhere.herokuapp.com/";
const months = ["January","February","March","April","May","Jun","July","August","September","October","November","December"];
const DB_API = 'http://cook.grabmobi.com/api/contents/mobiscope_content?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6';
var TJO = require("translate-json-object")();
let currentDate = new Date();
let year = currentDate.getFullYear();

export default {
  data() {
    return {
      data: {},
      data_desc: {},
      currentDateTranslate: "",
      date_current: [],
      sign: this.$route.params.sign,
      loading: true,
      image: "",
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
      horoscopeSlider: {}
    };
  },
  props: ["loadingPage"],
  computed: mapGetters(["language", "translateCode", "secondLang"]),
  beforeCreate(){
    
  },
  created() {
    this.getHorosign();
    this.getImage(this.sign);
    this.getHoroscopeDetails(this.sign);
  },
  updated(){
    if(this.$route.params.sign != this.sign){
      this.loading=true
      this.getHorosign();
      this.getImage(this.$route.params.sign);
      this.getHoroscopeDetails(this.$route.params.sign);

      this.sign = this.$route.params.sign
    }
  },
  mounted() {
    let sliderStatus = false;
    let width = window.innerWidth;

    window.addEventListener("resize", () => {
      let width = window.innerWidth;
      if (width <= 991 && !sliderStatus) {
        this.horoscopeSlider = new Flickity(
          this.$refs.mobileCarousel,
          this.flickityOptions
        );
        this.horoscopeSlider.resize();
        sliderStatus = true;
      } else if (width >= 991 && sliderStatus) {
        this.horoscopeSlider.destroy();
        sliderStatus = false;
      }
    });
  },

  methods: {
    intiMobileSlider(slideIndex) {
      this.flickityOptions.initialIndex = slideIndex;
      let width = window.innerWidth;
      if (width <= 991) {
        setTimeout(() => {
          this.horoscopeSlider = new Flickity(
            this.$refs.mobileCarousel,
            this.flickityOptions
          );
          this.horoscopeSlider.select(slideIndex);
          this.horoscopeSlider.on("staticClick",(event, pointer, cellElement, cellIndex) => {
              this.horoscopeSlider.select(cellIndex);
            }
          );
          this.horoscopeSlider.on("settle", (event, index) => {
            let sign = document.getElementsByClassName("is-selected")[0].innerText
            mobiscope_route.push({name: 'HoroscopeDetails', params: {sign: sign}}).catch(err => {})
            // this.getSun(document.getElementsByClassName("is-selected")[0].innerText);
          });
        }, 0);
      }
    },
    getHorosign() {
      let sign = this.$route.params.sign
      let si = sign.replace(/^./, sign[0].toUpperCase());
      horoscope_sign.horoscope.map((item)=>{
        item.icon = require(`../../assets/mobiscope/imgs/horoscope_icon/${item.name}.svg`);
      })
      this.data = horoscope_sign.horoscope
      this.data.map(item => {
        if (item.name == si) {
          let slideIndex = this.data.indexOf(item);
          this.intiMobileSlider(slideIndex);
        }
      });
    },
    getImage(sign) {
      //get image for each horoscope
      let s = "";
      s = sign.replace(/^./, sign[0].toUpperCase());
      this.image = require(`../../assets/mobiscope/imgs/zodiac_image/${s}.svg`);
    },
    async getHoroscopeDetails(sign) {
      let mon = currentDate.getUTCMonth()+1
      mon = '0'+ mon

      let horo_date = `${year}-${mon}-${currentDate.getUTCDate()}`;
      await axios.get(`${DB_API}&horoscope=${sign}&date=2021-06-24`).then((res)=>{
        this.data_desc = res.data.data[0].horoscope_description
        this.loading = false
      })

      let curr_date = `${months[currentDate.getUTCMonth()]} ${currentDate.getUTCDate()}, ${year}`;
      this.date_current['english'] = curr_date;

      if(this.secondLang != 'english'){
        TJO.init({
          googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04',
          // yandexApiKey:
          //   "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
        });

        var translate = {
          currentDateTranslate: curr_date
        };

        TJO.translate(translate, this.translateCode).then((data) => {
          this.date_current[this.secondLang] = data.currentDateTranslate
        })
      }
      //Get all horoscope i.e. today's, yesterday's and tomorrow's horoscope
      
    },
    getSun(sign) {
      this.loading = false
      //to change sign description without load page
      this.sign = sign;
      this.getImage(sign);
      this.getHoroscopeDetails(sign);
    }
  }
};
</script>

<style lang="scss">
.signIcon.blue {
  .signIcon__img {
    background: #450eff;
  }
  .shadow {
    background: #fff;
    width: 38px;
    height: 38px;
    transform: translateY(-50%);
    z-index: -1;
    top: 50%;
  }
  
  &:focus .signIcon__img {
    background: #450eff;
  }
  
  @media (min-width: 991px) {
    &:hover .signIcon__img {
      background: #dc00ac;
    }
  }
}
.is-selected {
  .signIcon.blue .signIcon__img {
    background: #dc00ac;
  }
  .signIcon.blue:hover .signIcon__img {
    background: #dc00ac;
  }
  .signIcon.blue:focus .signIcon__img {
    background: #450eff;
  }
}
#yesterday-tab,
#tomorrow-tab,
#week-tab,
#month-tab,
#year-tab,
#today-tab {
  height: 42px;
  width: 110px;
  text-align: center;
}

#yesterday, #today, #tomorrow{
  height: 120px;
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 15px;
}
.imagePlaceholder {
  width: 100%;
  max-width: 420px;
  height: 300px;
  img {
    width: 100%;
    height: 100%;
  }
}

.horo_icon {
  width: 30px;
}
// .nav-tabs.custom {
//   .nav-link {
//     color: #fff;
//     font-size: 1rem;
//     font-weight: 600;
//   }
//   .nav-link.active {
//     background: transparent;
//     border-bottom-color: #360fb5;
//   }
// }
.mobileCarousel {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .carousel-cell {
    width: 25%;
    margin-right: 10px;
    border-radius: 5px;
  }
  .flickity-viewport {
    width: 100%;
  }
  .flickity-page-dots .dot {
    background: #fff;
  }
}

//Responsive styles
@media (max-width: 991px) {
  .imagePlaceholder {
    margin: 0 auto;
    max-width: 220px;
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobiscope/HoroscopeDetails.vue